import React, { Component } from 'react';
import 'whatwg-fetch';
import _ from 'lodash';

class App extends Component {
    constructor(props) {
        super(props); //pass up to parent

        //initialize state
        this.state = {
            albums: [],
            indexOfDisplayedAlbum: undefined,
            searchTerm: undefined,
            errorMessage: undefined
        };

        //this.handleChange = this.handleChange.bind(this);
    }

    // Determines whether to show or hide album details
    toggleDetail(albumIndex) {
        if (this.state.indexOfDisplayedAlbum === albumIndex) {
            // Hides the album's details
            this.setState({ indexOfDisplayedAlbum: undefined });
        } else {
            // Shows the album's details
            this.setState({ indexOfDisplayedAlbum: albumIndex });
        }
    }

    // Alphabetizes the search results
    alphabetize(a, b) {
        if (a.collectionName > b.collectionName) {
            return 1;
        } else if (a.collectionName < b.collectionName) {
            return -1;
        } else {
            return 0;
        }
    }

    renderError(errorText) {
        let newError = <p className="alert alert-danger">{errorText}</p>
        this.setState({ errorMessage: newError });
    }

    // This changes the search term when the value typed into the <input> is changed
    handleChange(event) {
        this.setState({ searchTerm: event.target.value });
    }

    // This fetches the data and renders the album list when the search <button> is clicked on
    handleClick() {
        this.getData(this.state.searchTerm);
    }

    // Used to render the initial album list and all subsequent album lists
    getData(term) {
        const URL_TEMPLATE = "https://itunes.apple.com/search?term=";
        const URL_QUERY_PARAMS = "&entity=album&limit=25";
        fetch(URL_TEMPLATE + this.state.searchTerm + URL_QUERY_PARAMS)
            .then((res) => res.json())
            .then((data) => {
                // This removes repeated values (that occur due to the explicit & clean version of an album or single)
                let uniqueAlbums = _.uniqBy(data.results, 'collectionName');
                uniqueAlbums.sort(this.alphabetize);
                this.setState({ albums: uniqueAlbums });
                // This removes the error message when results are rendered properly
                this.setState({ errorMessage: undefined });
            }).catch((err) => {
                this.setState({ albums: [] });
                this.renderError("No results found");
            })
    }

    render() {
        let view = '';
        let results = this.state.albums;

        function mobileHelper() {
            if (results.length !== 0) {
                return (
                    <p className="text-center small-screens">
                        Tap on an album tab below to learn more about it!
                    </p>
                );
            }
        }

        if (this.state.albums.length > 0) {
            view = (
                <div>
                    <ListView
                        indexOfAlbumToDisplay={this.state.indexOfDisplayedAlbum}
                        albums={this.state.albums}
                        toggleDetail={(index) => { this.toggleDetail(index) }}
                    />
                    <SplitView
                        renderError={() => this.state.renderError()}
                        indexOfAlbumToDisplay={this.state.indexOfDisplayedAlbum}
                        albums={this.state.albums}
                        toggleDetail={(index) => { this.toggleDetail(index) }}
                    />
                </div>
            );
        }

        return (
            <div>
                <header className="jumbotron jumbotron-fluid">
                    <div className="container">
                        <h1 className="text-center">Album Finder</h1>
                    </div>
                </header>
                <main>
                    <Search
                        handleChange={(event) => this.handleChange(event)}
                        handleClick={() => this.handleClick()}
                    />
                    {this.state.errorMessage}
                    {mobileHelper()}
                    <div className="container maximize-container">
                        <div className="row">
                            {/* This is the main interactive point of the Application including the album list and detail */}
                            {view}
                        </div>
                    </div>
                </main>
                <footer>
                    <small className="container">Data from
                         <a href="https://goo.gl/uGhnxe"> Itunes Search API</a>
                    </small>
                    <small className="container">Tab icon from
                         <a href="https://goo.gl/3cF3S7"> Tristan Edwards</a>
                    </small>
                </footer>
            </div>
        );
    }

}

export default App;

// Interactive search input & button to query for desired album based on album name, artist name, 
// and sometimes the name of a single
class Search extends Component {
    render() {
        return (
            <div>
                <div className="container search-form center">
                    <div className="form-group">
                        <h2>What do you want to hear?</h2>
                        <input
                            type="text"
                            name="term"
                            id="searchQuery"
                            className="form-control" placeholder="Search for albums. . ."
                            onChange={(event) => this.props.handleChange(event)}
                        />
                    </div>
                    <button
                        type="submit"
                        className="btn btn-primary"
                        onClick={() => this.props.handleClick()}
                    >Search</button>
                    <h3>Results:</h3>
                </div>
            </div>
        );
    }
}

// Individual Album item - Clicking on this item will show the <AlbumDetail /> with information on 
// the album
class Album extends Component {
    render() {
        return (
            <div
                className="container preview"
                onClick={(e) => this.props.toggleDetail(this.props.index)}
            >
                <p className="text-center"><strong>{this.props.albumName}</strong></p>
                <p className="text-center">{this.props.artist}</p>
            </div>
        );
    }
}

// Detailed Mobile View - Extended information on the clicked album
class AlbumDetail extends Component {
    render() {
        // Reformatting explicit value for readability (notExplicit -> not explicit)
        let explicitness = this.props.explicitness;
        if (explicitness !== 'explicit') {
            explicitness = 'not explicit';
        }
        return (
            <div className="album center">
                <div className="center">
                    <img src={this.props.albumCover} alt={this.props.albumName} />
                </div>
                <p className="text-center">{this.props.genre}</p>
                <p className="text-center">{this.props.releaseDate.slice(0, 10)}</p>
                <p className="text-center">{explicitness}</p>
                <p className="text-center"><a href={this.props.link}>View this album on iTunes</a></p>
            </div>
        );
    }
}

// Main Mobile View - Clicking on an <Album /> in this view will cause an <AlbumDetail /> to appear 
// directly below the selected <Album />
class ListView extends Component {
    render() {
        let details = this.props.albums.map((album) => {
            return (
                <AlbumDetail
                    albumCover={album.artworkUrl100}
                    genre={album.primaryGenreName}
                    releaseDate={album.releaseDate}
                    explicitness={album.collectionExplicitness}
                    link={album.collectionViewUrl}
                />
            );
        });

        // Allows for more flexible use of value
        let indexOfAlbumToDisplay = this.props.indexOfAlbumToDisplay;

        // Inserts the album at the same index as its preview information 'tab'
        function insertAlbum(index) {
            if (index === indexOfAlbumToDisplay) {
                return details[indexOfAlbumToDisplay];
            }
            return undefined;
        }

        let albums = this.props.albums.map((album, index) => {
            return (
                <div key={album.collectionName} className="list-view-card">
                    <Album
                        index={index}
                        albumName={album.collectionCensoredName}
                        artist={album.artistName}
                        toggleDetail={this.props.toggleDetail}
                    />
                    <div className='container small'>
                        {insertAlbum(index)}
                    </div>
                </div>
            );
        });
        return (
            <div className="small-screens">
                {albums}
            </div>
        );
    }
}

// This renders the Preview Display content for medium & large screens when an album is not selected
class PreviewDisplay extends Component {
    render() {
        let PreviewDisplayAlbums = this.props.albums.slice(0, 4);
        PreviewDisplayAlbums = PreviewDisplayAlbums.map((album) => {
            return (
                <div className="col-sm-6">
                    <img src={album.artworkUrl100} alt={album.collectionCensoredName} />
                </div>
            );
        })

        return (
            <div className="container preview-display-content">
                <p className="text-center">
                    The following images are a preview of more detailed album information.
                </p>
                <p className="text-center">
                    To learn more about an album, select it from the list on the left.
                </p>
                <div className="row">
                    {PreviewDisplayAlbums[0]}
                    {PreviewDisplayAlbums[1]}
                </div>
                <div className="row">
                    {PreviewDisplayAlbums[2]}
                    {PreviewDisplayAlbums[3]}
                </div>
            </div>
        )
    }
}

// Main Desktop View - Allows for click interaction
class SplitView extends Component {
    render() {
        // Determine the number of results displayed for the 'master' section based on the screen height
        // with a minimum of 4 results
        let screenHeight = (
            window.innerHeight || document.body.clientHeight || document.documentElement.clientHeight
        );
        let results = ((Math.floor(screenHeight / 62)) > 4) ? (Math.floor(screenHeight / 62)) : 4;
        // The total search results are trimmed to accomodate screen height
        let displayableAlbums = this.props.albums.slice(0, results);

        if (displayableAlbums < 4) {
            this.props.renderError("Too few results");
            return undefined;
        }

        // This is the album preview list which will act as the 'master' or control section of the screen
        let albumPreviewList = displayableAlbums.map((album, index) => {
            return (
                <div key={album.collectionName} className="list-view-card">
                    <Album
                        index={index}
                        albumName={album.collectionCensoredName}
                        artist={album.artistName}
                        toggleDetail={this.props.toggleDetail} />
                </div>
            );
        });

        // These are the album details which are the 'detail' or content section of the screen
        let albumDetailComponents = displayableAlbums.map((album) => {
            return (
                <div key={album.collectionName} id={album.collectionCensoredName} className='container large'>
                    <p className="text-center"><strong>{album.collectionCensoredName}</strong></p>
                    <p className="text-center">{album.artistName}</p>
                    <AlbumDetail
                        albumCover={album.artworkUrl100}
                        genre={album.primaryGenreName}
                        releaseDate={album.releaseDate}
                        explicitness={album.collectionExplicitness}
                        link={album.collectionViewUrl} />
                </div>
            );
        });

        let indexOfAlbumToDisplay = this.props.indexOfAlbumToDisplay;
        let previewDisplayAlbums = this.props.albums;

        function displayDetail() {
            let detail = undefined;
            if (indexOfAlbumToDisplay + 1) {
                detail = (
                    <div id="large-albums" className="center">
                        {albumDetailComponents[indexOfAlbumToDisplay]}
                    </div>
                );
            } else {
                detail = (
                    <div id="large-preview" className="center">
                        <PreviewDisplay albums={previewDisplayAlbums} />
                    </div>
                );
            }
            return detail;
        }

        return (
            <div className="medium-large-screens">
                <div className="master col-sm-2 col-md-4">
                    {albumPreviewList}
                </div>
                <div className='large-detail col-sm-6 col-md-8'>
                    {displayDetail()}
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/App.js